import React from "react";
import underMaintenancePng from "../../assets/under_maintainace.png";

export default function UnderMaintenance() {
  return (
    <div className="no-page-wrapper">
      <img
        src={underMaintenancePng}
        alt="under-maintenance"
        className="error-img"
      />
      <p className="go-to-text" />
    </div>
  );
}
